<template>
<w-sliding-popup ref="slidingPopup" :title="title" width="600px" @close="closed" class="dashboard-group-setting-popup">
  <div slot="content" style="height: calc(100% - 7px)">
    <el-form :model="data" :rules="rules" ref="form">
      <el-row>
        <el-form-item label="대시보드 구분">
          <el-select v-model="data.dashboardType" style="width: 100%;" :disabled="type === DashboardConst.SET_TYPE.EDIT">
            <el-option label="기본 대시보드" :value="DashboardConst.DASHBOARD_TYPE.GRID"></el-option>
            <el-option label="커스텀 대시보드" :value="DashboardConst.DASHBOARD_TYPE.COORD"></el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="대시보드 그룹명" prop="dashboardGroupName">
          <el-input v-model="data.dashboardGroupName" @change="data.label = data.dashboardGroupName" placeholder="대시보드 그룹명을 입력해주십시오."></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="대시보드 그룹 설명">
          <el-input resize="none" type="textarea" :rows="5" v-model="data.dashboardGroupDesc" placeholder="대시보드 그룹 설명을 입력해주십시오."></el-input>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
  <el-row slot="footer">
    <el-col :span="24">
      <el-row type="flex" justify="center" align="middle">
        <el-button class="mr-r4" size="large" type="solid" @click="onSaveClick">저장</el-button>
        <el-button size="large" @click="close">취소</el-button>
      </el-row>
    </el-col>
  </el-row>
</w-sliding-popup>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';

import DashboardConst from '@/constants/dashboard';

export default {
  name: 'WDashboardGroupSettingPopup',
  components: {
  },
  data() {
    return {
      DashboardConst,
      type: DashboardConst.SET_TYPE.ADD,
      orgData: {},
      data: {},
      rules: {
        dashboardGroupName: [
          {
            required: true,
            message: '대시보드 그룹명을 입력해주십시오.',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    title() {
      let title = '';

      if (this.type === DashboardConst.SET_TYPE.ADD) {
        title = '대시보드 그룹 추가';
      } else if (this.type === DashboardConst.SET_TYPE.EDIT) {
        title = `[${this.orgData.label}] 수정`;
      }

      return title;
    },
  },
  created() {
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.DASHBOARD_GRP_SET, this.open);
  },
  beforeDestroy() {
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.DASHBOARD_GRP_SET, this.open);
  },
  methods: {
    onSaveClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.type === DashboardConst.SET_TYPE.ADD) {
            if (this.data.dashboardType === DashboardConst.DASHBOARD_TYPE.GRID) {
              this.orgData.gridDashboardTree.push(cloneDeep(this.data));
            } else {
              this.orgData.coordDashboardTree.push(cloneDeep(this.data));
            }
          } else {
            merge(this.orgData, this.data);
          }
          this.close();
        } else {
          return false;
        }

        return true;
      });
    },
    open(type, data, dashboardType) {
      this.resetForm();

      this.type = type;
      this.orgData = data;

      if (this.type === DashboardConst.SET_TYPE.ADD) {
        this.data = this.createData();

        // 대시보드 구분 설정
        if (dashboardType) {
          this.data.dashboardType = dashboardType;
        }
      } else {
        this.data = cloneDeep(this.orgData);
      }

      this.$refs.slidingPopup.open();
    },
    close() {
      this.$refs.slidingPopup.close();
    },
    closed() {
      this.type = DashboardConst.SET_TYPE.ADD;
      this.orgData = {};
      this.data = {};
    },
    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    createData() {
      return {
        label: '',
        dashboardGroupName: '',
        dashboardGroupDesc: '',
        dashboardType: DashboardConst.DASHBOARD_TYPE.GRID,
        itemLevel: 'GROUP',
        leaf: false,
        defaultFlag: 'N',
        children: [],
      };
    },
  },
};
</script>
<style>
.dashboard-group-setting-popup .body-content {
  height: 100%;
}
</style>
<style module>
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/popup/DashboardGroupSettingPopup.vue